import { useQuery } from "@apollo/client";
import CollectionTypeShowQuery from "../graphql/queries/CollectionTypeShowQuery.graphql";
import CollectionTypeEditQuery from "../graphql/queries/CollectionTypeEditQuery.graphql";
import type {
  CollectionTypeShowQueryType,
  CollectionTypeShowQueryVariablesType,
  CollectionTypeEditQueryType,
  CollectionTypeEditQueryVariablesType,
} from "@/types/graphql/admin.generated";

export function useCollectionTypeShowQuery(id: string | null, skip = false) {
  return useQuery<
    CollectionTypeShowQueryType,
    CollectionTypeShowQueryVariablesType
  >(CollectionTypeShowQuery, {
    variables: id ? { id } : undefined,
    skip: skip || !id,
  });
}

export function useCollectionTypeEditQuery(id: string | null, skip = false) {
  return useQuery<
    CollectionTypeEditQueryType,
    CollectionTypeEditQueryVariablesType
  >(CollectionTypeEditQuery, {
    variables: id ? { id } : undefined,
    skip: skip || !id,
  });
}
